import { render, staticRenderFns } from "./BannerTasks.vue?vue&type=template&id=41e66678&scoped=true&"
import script from "./BannerTasks.vue?vue&type=script&lang=js&"
export * from "./BannerTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e66678",
  null
  
)

export default component.exports